<template>
  <v-container class="content">
    <v-card class="pa-3 pb-5">
      <v-flex class="row mx-3 my-2">
        <v-layout align-center>
          <span class="title font-weight-medium">Programas</span>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
      <v-divider class="mx-3"></v-divider>
      <v-flex class="row mx-3 mb-2">
        <v-text-field
          placeholder="Filtrar"
          append-icon="search"
          hide-details
          class="pt-0 mb-1"
          v-model="search"
        ></v-text-field>
        <br /><br /><br />
      </v-flex>
      <v-flex class="col" v-if="programs">
        <v-data-table
          no-data-text="Nenhuma oferta cadastrada"
          :headers="headers"
          :items="programs"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:item="{ item }">
            <td>{{ item.name }}</td>
            <td>{{ item.status | status }}</td>
            <td>{{ item.status_program | status }}</td>
            <td>
              <v-icon
                v-if="!item.status_program"
                small
                @click="openRateio(item.id)"
              >
                check
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
    <ModalRateio
      v-if="showModal"
      :show="showModal"
      :clientId="clientId"
      @close="alterShowModal"
      @activeProgram="activeProgram"
    />
  </v-container>
</template>

<script>
import ProgramsConfigController from "../../controllers/ProgramsConfigController";
import ModalRateio from "./ModalRateio";
export default {
  components: {
    ModalRateio
  },
  data() {
    return {
      programsConfigController: new ProgramsConfigController(this.$resource),
      programs: [],
      headers: [
        {
          text: "Cliente",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Status cliente", value: "status" },
        { text: "Status Programa", value: "status_program" },
        { text: "Ações", value: "action", sortable: false }
      ],
      search: "",
      showModal: false,
      clientId: null,
      profile: localStorage.getItem("profile"),
      clientId: localStorage.getItem("client_id")
    };
  },
  created() {
    this.getPrograms();
  },
  methods: {
    getPrograms() {
      if (this.profile == "tcs") {
        this.programsConfigController.getAll(this.clientId).then(res => {
          this.programs = res;
        });
      } else {
        this.programsConfigController.getAllByClient().then(res => {
          this.programs = res;
        });
      }
    },
    openRateio(client_id) {
      this.alterShowModal();
      this.clientId = client_id;
    },
    alterShowModal() {
      this.showModal = !this.showModal;
    },
    activeProgram(users, rateio) {
      this.programsConfigController
        .activeProgram(this.clientId, users, rateio)
        .then(res => {
          this.getPrograms();
          this.alterShowModal();
          this.$awn.success("Programa ativo com sucesso.");
        })
        .catch(error => {
          this.$awn.alert("Falha ao ativa programa.");
        });
    }
  },
  filters: {
    status(sts) {
      return sts ? "Ativado" : "Desativado";
    }
  }
};
</script>

<style></style>
